(() => {
    document.addEventListener('viewToggler.beforeHide', e => {
        if (e.detail.element.id === 'journals-list') {
            $(e.detail.element).slideUp('fast');
        }
    });

    document.addEventListener('viewToggler.beforeShow', e => {
        if (e.detail.element.id === 'journals-list') {
            $(e.detail.element).slideDown('fast');
        }
    });
})();
